module.exports = __webpack_public_path__ + "static/img/dormido.baf4359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/dormido.png
// module id = 234
// module chunks = 1